import { modals } from './modals'

export const orderTracking = {
    init: () => {
        console.debug("order-tracking.js: init");
        // Format the prices with thousand seperated by space 
        $(".TrackMyOrder-formatNumber").each(function (index) {
            $(this).html(orderTracking.formatNumberWithSpaces($(this).html()));
        });

        $(".TrackMyOrder-informationcircle").click(function () {
            if (window.innerWidth < 992) {
                alert($(this).find(".tooltip-text").text().trim());
            }
        });


    },
    formatNumberWithSpaces: (numberstring) => {
        // Code from stackoverflow
        return numberstring.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

}